<div
  class="rounded-lg border bg-card text-card-foreground shadow-xs h-full overflow-hidden flex flex-col"
>
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <div class="flex flex-row items-center gap-x-4">
      <a
        href="/inventario"
        target="_self"
        class="w-8 h-8 flex items-center justify-center text-slate-400 text-4xl transition-all hover:text-5xl"
      >
        <ng-icon name="lucideChevronLeft"></ng-icon>
      </a>
      <div class="flex flex-col content-around justify-between">
        <h3 class="text-2xl font-semibold leading-none tracking-tight">
          {{ productName }}
        </h3>
        <span class="text-muted-foreground">
          {{ productDescription }}
        </span>
      </div>
    </div>

    <button type="button" class="primary normal" (click)="openModal()">
      + Nuevo Rollo
    </button>
  </div>

  <div
    class="grow h-full flex items-start p-6 pt-0 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
  >
    <div class="h-full w-full">
      <table class="w-full">
        <thead>
          <tr class="border-b border-border">
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              ID
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Proveedor
            </th>
            <th
              class="text-left py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Almacén
            </th>
            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Color
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Ancho
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Actual <br />(m)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Actual <br />(kg)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Reservado <br />(m)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Reservado <br />(kg)
            </th>
            <th
              class="text-right py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Costo / UDM
            </th>
            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Estatus
            </th>
            <th
              class="text-center py-3 px-4 text-muted-foreground font-medium text-sm"
            >
              Acciones
            </th>
          </tr>
        </thead>

        <tbody>
          @for(roll of productRolls; track roll.id) {
          <tr class="border-b border-border hover:bg-accent transition-colors">
            <td class="py-4 px-4">
              <span class="text-foreground text-xs">{{
                roll.roll_identifier
              }}</span>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs">
              {{ roll.supplier_name }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs">
              {{ roll.warehouse_name }}
            </td>
            <td class="py-4 px-4">
              <div class="flex justify-center items-center">
                <app-color-total [color]="roll.color"></app-color-total>
              </div>
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.width | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.current_length_meters | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.current_weight_kg | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.reserved_length_meters | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.reserved_weight_kg | number : "1.2-2" }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-right">
              {{ roll.purchase_cost | currency : "MXN" }} /
              {{ roll.purchase_cost_uom }}
            </td>
            <td class="py-4 px-4 text-muted-foreground text-xs text-center">
              {{ roll.status }}
            </td>
            <td class="py-4 px-4">
              <div class="flex items-center space-x-1">
                <button
                  class="ghost sm text-muted-foreground hover:text-foreground"
                  type="button"
                  (click)="updateRoll(roll)"
                >
                  <ng-icon
                    name="lucidePenLine"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>

                <button
                  class="ghost sm text-destructive"
                  type="button"
                  (click)="deleteRoll(roll.id)"
                >
                  <ng-icon
                    name="lucideTrash2"
                    class="w-5 h-5 text-secondary-foreground"
                  />
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<app-roll-form
  [(showModal)]="showModal"
  [productId]="productId"
  [(existingRoll)]="existingRoll"
></app-roll-form>
